import React, { useEffect, useRef, useState } from 'react';
import { CoreLink } from '@uncinc/react-drupal-core';
import { useTranslation } from 'react-i18next';

import './style.scss';

const DONATION_INTERVAL_MONTHLY = 'monthly';
const DONATION_INTERVAL_SINGLE = 'single';

const AVAILABLE_DONATION_INTERVALS = [
  DONATION_INTERVAL_MONTHLY,
  DONATION_INTERVAL_SINGLE,
];

const DonationInitializerBlock = ({ entity, props, setAmountSelected, setIntervalSelected }) => {
  const { title, linkUrlComplete, linkTitle, amountSelected, intervalSelected } = props;
  const { t } = useTranslation();
  const inputRef = useRef(null);
  const [errors, setErrors] = useState(null);

  const subtitle = entity.getIn(['field_title', 0, 'value'], '');
  const amountsString = entity.getIn(['field_amounts', 0, 'value'], '');
  const amountsArray = amountsString ? amountsString.split(',') : [];
  const amountDefault = entity.getIn(['field_amount_default', 0, 'value'], 0);
  const intervalDefault = entity.getIn(['field_interval_default_', 0, 'value'], DONATION_INTERVAL_MONTHLY);

  const amount = amountSelected || amountDefault;
  const interval = intervalSelected || intervalDefault;

  const isSelected = (match, value) => (match === value ? 'Button Button--selected' : 'Button');

  const clearInput = () => {
    inputRef.current.value = '';
  };

  const onChangeHandler = (e) => {
    const newValue = e.target.value;
    const isValidAmount = Number.isInteger(Number(newValue)) && Number(newValue) > 0;

    if (!isValidAmount) {
      setErrors(t('donationform.error'));
      clearInput();
      setAmountSelected(amountDefault);
    } else {
      setErrors(null);
      setAmountSelected(newValue);
    }
  };

  useEffect(() => {
    setAmountSelected(amount);
    setIntervalSelected(interval);
    setErrors(null);
  }, [amount, interval, setAmountSelected, setIntervalSelected]);

  return (
    <div className="DonationInitializer">
      <div className="DonationInitializer__wrapper">
        {title && <div className="DonationInitializer__wrapper__title"><h2>{title}</h2></div>}
        <div className="DonationInitializer__wrapper__subtitle">{subtitle}</div>

        <div className="DonationInitializer__wrapper__buttons">
          {AVAILABLE_DONATION_INTERVALS.map((intervalOption) => (
            <button
              key={intervalOption}
              type="button"
              className={isSelected(intervalOption, interval)}
              onClick={() => setIntervalSelected(intervalOption)}
            >
              {t(`donationform.${intervalOption}`)}
            </button>
          ))}
        </div>

        <div className="DonationInitializer__wrapper__buttons">
          {amountsArray.map((amountOption) => (
            <button
              key={amountOption}
              type="button"
              className={isSelected(amountOption, amount)}
              onClick={() => {
                setAmountSelected(amountOption);
                clearInput();
              }}
            >
              € {amountOption}
            </button>
          ))}
        </div>

        <div className="DonationInitializer__wrapper__other-amount">
          <input
            name="otherAmount"
            ref={inputRef}
            type="number"
            min="0"
            className="amount"
            onChange={onChangeHandler}
            placeholder="..."
          />

          <label htmlFor="otherAmount" className="DonationInitializer__placeholder">
            {t('donationform.other_amount')}
          </label>

          {errors && <span className="error">{errors}</span>}
        </div>

        {linkUrlComplete && (
          <div className="DonationInitializer__wrapper__buttons">
            <CoreLink className="Button Button--submit" to={linkUrlComplete}>
              {linkTitle}
              <i className="icon icon-arrow-right-filled icon-variant-1" />
            </CoreLink>
          </div>
        )}
      </div>
    </div>
  );
};

export default DonationInitializerBlock;
